import React from 'react';

const MobileInterstitiel = ({ iconURL, handleMarketingNavigation }) => {

  return (
    <img className="interstitielMobile" alt="cover" src={iconURL} onClick={() => handleMarketingNavigation()} />
  )
}

export default MobileInterstitiel